import React, { forwardRef } from 'react';

import { Consumer } from './ResponsiveContext';

const isResponsive = Component =>
  forwardRef((props, ref) => (
    <Consumer>
      {responsive => <Component {...props} {...{ responsive, ref }} />}
    </Consumer>
  ));

export default isResponsive;



// WEBPACK FOOTER //
// ./src/lib/isResponsive.js